import { getCurrentUrl } from "./Utils";
export var ConnextUserAgent;
(function (ConnextUserAgent) {
    ConnextUserAgent.DeviceTypes = {
        'Desktop': 'Desktop',
        'Mobile': 'Mobile',
        'Tablet': 'Tablet',
        'Default': 'Default'
    };
    let OSTypes;
    (function (OSTypes) {
        OSTypes["IOS"] = "IOS";
        OSTypes["windows"] = "windows";
        OSTypes["android"] = "android";
        OSTypes["blackberry"] = "blackberry";
        OSTypes["fxos"] = "fxos";
    })(OSTypes = ConnextUserAgent.OSTypes || (ConnextUserAgent.OSTypes = {}));
    let BrowserTypes;
    (function (BrowserTypes) {
        BrowserTypes["Opera"] = "Opera";
        BrowserTypes["Edge"] = "Edge";
        BrowserTypes["Chrome"] = "Chrome";
        BrowserTypes["Safari"] = "Safari";
        BrowserTypes["Firefox"] = "Firefox";
        BrowserTypes["IE"] = "IE";
        BrowserTypes["Facebook"] = "Facebook";
        BrowserTypes["unknown"] = "unknown";
    })(BrowserTypes = ConnextUserAgent.BrowserTypes || (ConnextUserAgent.BrowserTypes = {}));
    class UserAgent {
        constructor() {
            this.userAgent = window.navigator.userAgent.toLowerCase();
        }
        getDeviceType() {
            if (this.mobile()) {
                return ConnextUserAgent.DeviceTypes.Mobile;
            }
            else if (this.tablet()) {
                return ConnextUserAgent.DeviceTypes.Tablet;
            }
            else if (this.desktop()) {
                return ConnextUserAgent.DeviceTypes.Desktop;
            }
        }
        getOS() {
            if (this.ios()) {
                return OSTypes.IOS;
            }
            else if (this.windows()) {
                return OSTypes.windows;
            }
            else if (this.android()) {
                return OSTypes.android;
            }
            else if (this.blackberry()) {
                return OSTypes.blackberry;
            }
            else if (this.fxos()) {
                return OSTypes.fxos;
            }
        }
        getBrowser() {
            if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) !== -1) {
                return BrowserTypes.Opera;
            }
            else if (navigator.userAgent.indexOf("Edg") !== -1) {
                return BrowserTypes.Edge;
            }
            else if (navigator.userAgent.indexOf("Chrome") !== -1) {
                return BrowserTypes.Chrome;
            }
            else if (navigator.userAgent.indexOf("Safari") !== -1) {
                return BrowserTypes.Safari;
            }
            else if (navigator.userAgent.indexOf("Firefox") !== -1) {
                return BrowserTypes.Firefox;
            }
            else if ((navigator.userAgent.indexOf("MSIE") !== -1) || (!!document.documentMode === true)) { // IF IE > 10
                return BrowserTypes.IE;
            }
            else if ((navigator.userAgent.indexOf("FBAN") > -1) || (navigator.userAgent.indexOf("FBAV") > -1)) {
                return BrowserTypes.Facebook;
            }
            else {
                return BrowserTypes.unknown;
            }
        }
        getUserMeta() {
            return {
                Browser: this.getBrowser(),
                OS: this.getOS(),
                deviceType: this.getDeviceType(),
                URL: getCurrentUrl()
            };
        }
        find(needle) {
            return this.userAgent.indexOf(needle) !== -1;
        }
        ;
        ios() {
            return this.iphone() || this.ipod() || this.ipad();
        }
        ;
        iphone() {
            return !this.windows() && this.find("iphone");
        }
        ;
        ipod() {
            return this.find("ipod");
        }
        ;
        ipad() {
            return this.find("ipad");
        }
        ;
        android() {
            return !this.windows() && this.find("android");
        }
        ;
        androidPhone() {
            return this.android() && this.find("mobile");
        }
        ;
        androidTablet() {
            return this.android() && !this.find("mobile");
        }
        ;
        blackberry() {
            return this.find("blackberry") || this.find("bb10") || this.find("rim");
        }
        ;
        blackberryPhone() {
            return this.blackberry() && !this.find("tablet");
        }
        ;
        blackberryTablet() {
            return this.blackberry() && this.find("tablet");
        }
        ;
        windows() {
            return this.find("windows");
        }
        ;
        windowsPhone() {
            return this.windows() && this.find("phone");
        }
        ;
        windowsTablet() {
            return this.windows() && (this.find("touch") && !this.windowsPhone());
        }
        ;
        fxos() {
            return (this.find("(mobile;") || this.find("(tablet;")) && this.find("; rv:");
        }
        ;
        fxosPhone() {
            return this.fxos() && this.find("mobile");
        }
        ;
        fxosTablet() {
            return this.fxos() && this.find("tablet");
        }
        ;
        meego() {
            return this.find("meego");
        }
        ;
        cordova() {
            return window.cordova && location.protocol === "file:";
        }
        ;
        nodeWebkit() {
            return typeof window.process === "object";
        }
        ;
        mobile() {
            return this.androidPhone() || this.iphone() || this.ipod() || this.windowsPhone() || this.blackberryPhone() || this.fxosPhone() || this.meego();
        }
        ;
        tablet() {
            return this.ipad() || this.androidTablet() || this.blackberryTablet() || this.windowsTablet() || this.fxosTablet();
        }
        ;
        desktop() {
            return !this.tablet() && !this.mobile();
        }
        ;
        isIOS() {
            return this.getOS() === OSTypes.IOS;
        }
    }
    ConnextUserAgent.userAgent = new UserAgent();
})(ConnextUserAgent || (ConnextUserAgent = {}));
